module.exports = __webpack_public_path__ + "img/honeybee.88f2dbea.png";